import {Component, computed, inject, input} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatTooltip} from '@angular/material/tooltip';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MapService} from '../../../services/map.service';
import {Coordinate} from 'ol/coordinate';
import {transform as transformCoordinates} from 'ol/proj';
import domtoimage from 'dom-to-image';

@Component({
  selector: 'tgrid-map-controls',
  imports: [
    MatButton,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatTooltip,
    ReactiveFormsModule,
  ],
  templateUrl: './map-controls.component.html',
  standalone: true,
  styleUrl: './map-controls.component.scss',
})
export class MapControlsComponent {

  protected mapService = inject(MapService);

  protected mapId = input<string>();
  protected view = computed(() => {
    return MapService.getMapRef(this.mapId())!.getView();
  });
  private mapRef = computed(() => {
    return MapService.getMapRef(this.mapId());
  });




  // Move to Component
  protected coordinateGroup = new FormGroup({
    latitude: new FormControl<number | undefined>(undefined, {nonNullable: true}),
    longitude: new FormControl<number | undefined>(undefined, {nonNullable: true}),
  });


  protected zoom(stepSize: number = 1): void {
    this.view().animate({
      zoom: (this.view().getZoom() || 0 )  + stepSize,
      duration: 100,
    });

  }

  protected togglePointSelection() {
    this.mapService.pointSelectionActive = !this.mapService.pointSelectionActive;
    MapService.getMapRef(this.mapId())!.getTargetElement().style.cursor = (this.mapService.pointSelectionActive) ? 'crosshair' : '';
  }

  protected goToPoint(coordinate?: Coordinate): void {
    if(!coordinate) {
      coordinate = transformCoordinates([
        this.coordinateGroup.value.longitude as number,
        this.coordinateGroup.value.latitude as number,
      ], 'EPSG:4326', 'EPSG:3857');
    }

    this.mapService.goToPoint$.next(coordinate);
  }

  exportAsPng() {
    const exportOptions = {
      filter: (node: Node): boolean =>  {
        const element = node as HTMLElement;
        const className = element.className || '';
        return (
          className.indexOf('ol-control') === -1 ||
          className.indexOf('ol-legend') > -1 ||
          (className.indexOf('ol-attribution') > -1 &&
            className.indexOf('ol-uncollapsible') > -1)
        );
      },
    };

    this.mapRef()!.once('rendercomplete', () => {
      domtoimage
        .toPng(this.mapRef()!.getTargetElement(), exportOptions)
        .then((dataURL: string) =>  {
          const linkTag = document.createElement('a');
          linkTag.download = 'tasti_grid_map.png';
          linkTag.href = dataURL;
          linkTag.click();
        });
    });
    this.mapRef()!.renderSync();
  }
}
